<template>
  <div class="block">
    <div class="block-title">快手小程序-团购券</div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="团购券使用情况" name="first">
        <ks-coupon-group :activeName="activeName" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import KsCouponGroup from "./KsCouponGroup";
export default {
  components: {
    KsCouponGroup,
  },
  data() {
    return {
      activeName: "first",
      agentName: "",
    };
  },
  mounted() {},

  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/couponGroup/index.vue